import React from 'react'

const header = () => {
    return (
        <>
        <header className="header">
            <div>
                <h1>Information about countries of the world</h1>
                </div>
        </header>
        </>
    )
}

export default header;
